import React from "react";

export default function BudgetAdjustmentReportComponent() {
  return <div></div>;
}
